import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Injectable({
  providedIn: 'root'
})
export class HtmlSanitizerService {
  constructor(private sanitizer: DomSanitizer) { }

  sanitizeHtml(content: any, withOutByPass = false): SafeHtml {
    content = (content || '').toString();
    // Use DOMPurify to remove scripts, styles tags but allow inline styles
    const sanitizedContent = typeof window !== 'undefined' ? DOMPurify.sanitize(content, {
      ALLOWED_TAGS: [
        // ✅ Text Formatting
        'a', 'b', 'i', 'u', 'strong', 'em', 'small', 'sub', 'sup', 'mark', 'del', 'ins', 's',

        // ✅ Headings
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',

        // ✅ Blocks & Layout
        'p', 'div', 'span', 'blockquote', 'pre', 'code',

        // ✅ Lists
        'ul', 'ol', 'li', 'dl', 'dt', 'dd',

        // ✅ Line Breaks & Horizontal Rules
        'br', 'hr',

        // ✅ Tables
        'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'colgroup', 'col',

        // ✅ Media
        'img', 'figure', 'figcaption', 'iframe', 'audio', 'video', 'source', 'embed',

        // ✅ Forms (if needed)
        'form', 'input', 'textarea', 'button', 'label', 'select', 'option', 'fieldset', 'legend',

        // ✅ Styles & Containers
        'style', 'section', 'article', 'aside', 'details', 'summary', 'nav', 'header', 'footer', 'main', 'address', 'canvas'
      ],
      FORBID_TAGS: ['script'], // Explicitly disallow <script> tag
      ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder']
    }) : content;

    if (withOutByPass) return sanitizedContent;
    // Trust the sanitized HTML (safe to render)
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedContent);
  }
}
